// @flow

import type {
  AssetsById,
} from 'fc-model-assets/types'

import {
  TREE,
  BRANCH,
} from '../constants'

import traverse from 'fc-utils/traverse'

export default (traverse([TREE, BRANCH]): (state: Object) => AssetsById)
